<template>
  <div>

    <div v-show="xValues&&xValues.length>0"
         :id="myId"
         style="width:100%;height:270rem"></div>
    <div class='no_data'
         v-show="!xValues||xValues.length==0">暂无数据</div>
  </div>

</template>

<script>
export default {
  data () {
    return {
      myChart: undefined
    }
  },
  props: ['myId', 'xValues', 'color', 'series'],
  watch: {
    xValues () {

      this.clear()
      if (this.xValues && this.xValues.length > 0)
        this.$nextTick(() => {
          this.drawLine()
        })

    }
  },
  methods: {
    clear () {
      // let myChart = this.$echarts.init(document.getElementById('myCharts'))
      if (this.myChart) {
        this.myChart.dispose()
      }
    },
    drawLine () {
      this.myChart = this.$echarts.init(document.getElementById(this.myId))
      this.myChart.setOption({
        tooltip: {
          trigger: 'axis',
        },
        color: this.color,
        grid: {
          top: '5%',
          left: '3%',
          right: '4%',
          bottom: '10%',
          containLabel: true
        },
        dataZoom: [
          {
            type: 'slider',
            xAxisIndex: [0, 1],
            startValue: 0,
            endValue: 5,
          },
          {
            type: 'inside',
            xAxisIndex: [0, 1],
            startValue: 0,
            endValue: 5,
          },
        ],
        toolbox: {
          show: false,
          feature: {
            saveAsImage: {},
          }
        },
        dataZoom: [
          {
            show: true,
            realtime: true,
            start: 0,
            end: 30,
            xAxisIndex: [0, 1]
          },
          {
            type: 'inside',
            realtime: true,
            start: 0,
            end: 30,
            xAxisIndex: [0, 1]
          }
        ],
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: this.xValues
        },
        yAxis: {
          type: 'value',
          max: 100
        },
        series: this.series
      })
      window.addEventListener('resize', this.resizeChart)

    },
    resizeChart () {
      this.myChart.resize()
    }

  },
  destroyed () {
    window.removeEventListener('resize', this.resizeChart)
  }
}
</script>

<style lang='scss' scoped>
.no_data {
  text-align: center;
  line-height: 200rem;
  color: #ccc;
}
</style>